import { Button, ButtonGroup, Field, TextAreaInput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import WorksheetCheckedBySection from 'Components/Worksheets/Core/WorksheetCheckedBySection';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core/types';
import { hasNonEmptyValue } from 'Lib/Any';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { WorksheetImageSectionGroup } from './WorksheetImageSectionGroup';
import { IImageAttachmentModel } from './types';

let WorksheetImagesAndRemarksSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
  addArrayEntry,
  prefixName,
}) => {
  const [showInternalRemarks, setShowInternalRemarks] = useState(
    useSelector(pipe(createWorksheetSelector!('ImagesAndRemarks.InternalRemarks'), hasNonEmptyValue))
  );

  const imageCount = useSelector(
    pipe(
      createWorksheetSelector!('ImagesAndRemarks.Images'),
      (i: Array<IImageAttachmentModel> | undefined) => (i ?? []).length
    )
  );
  const isWorksheetSaving = useSelector((s) => s.worksheetEditor.status.saving);

  const addImage = () => {
    addArrayEntry!({
      name: prefixName!('ImagesAndRemarks.Images'),
      index: imageCount,
      sync: true,
      data: {},
    });
  };

  const onAddInternalRemarksClick = () => {
    setShowInternalRemarks(true);
  };

  return (
    <NamePrefixModifier appendNamePrefix={'ImagesAndRemarks'}>
      <SectionGroup>
        <NamePrefixModifier appendNamePrefix={'Images'}>
          {Array.from({ length: imageCount }, (_, i) => (
            <WorksheetImageSectionGroup index={i} key={i} />
          ))}
          <ButtonGroup>
            <Button onClick={() => addImage()} disabled={isWorksheetSaving}>
              Add Image
            </Button>
          </ButtonGroup>
        </NamePrefixModifier>
        <ListFieldSection heading="Remarks" wide>
          <Field input={<TextAreaInput />} rows={4} name="Remarks" />
        </ListFieldSection>

        <ButtonGroup>
          <Button onClick={() => onAddInternalRemarksClick()} visible={!showInternalRemarks}>
            Add Internal Remarks
          </Button>
        </ButtonGroup>

        <ListFieldSection heading="Internal Remarks" wide visible={showInternalRemarks}>
          <Field input={<TextAreaInput />} rows={4} name="InternalRemarks" />
        </ListFieldSection>

        <WorksheetCheckedBySection />
      </SectionGroup>
    </NamePrefixModifier>
  );
};

WorksheetImagesAndRemarksSection = withInjectedProps(WorksheetImagesAndRemarksSection);

export { WorksheetImagesAndRemarksSection };
